import React from 'react';
import { Container } from 'react-bootstrap';

import Navbar from '../components/helpers/Navbar';
import UpdatePasswordForm from '../components/settings-page/UpdatePasswordForm';
import Footer from '../components/helpers/Footer';
import UserSettings from '../components/settings-page/UserSettings';

const SettingsPage = ({ darkMode, setDarkMode }) => {
  return (
    <div>
        <Navbar />
        <Container className="my-5">
          <strong><h2 className="text-primary-dark mb-5">Setări Cont</h2></strong>
          <UpdatePasswordForm />
          <UserSettings darkMode={darkMode} setDarkMode={setDarkMode} />
        </Container>
        <Footer />
    </div>  
  );
};

export default SettingsPage;
